export default "__VITE_ASSET__CFPqYOCn__"